import React from 'react';
import PropTypes from 'prop-types';
import CardLink from '../card-link';
import { Container } from '../styled/containers';
import {
  BannerBackground,
  BannerText,
  HeaderText,
  SubHeaderText,
  CardBanner,
  CardRow,
} from './styles';

/**
 * Displays a set of card links inside an assembly banner with title and subheader
 */
const CardLinksAssembly = ({
  title,
  subTitle,
  contentCards = [],
  removeMarginBottom,
}) => {
  if (!contentCards || !contentCards.length) return null;

  const assemblyAnalyticsData = {
    event: 'cardClick',
    cardRow: title,
    cardContext: subTitle,
  };

  return (
    <BannerBackground $removeMarginBottom={removeMarginBottom}>
      <Container>
        <CardBanner $removeMarginBottom={removeMarginBottom}>
          <BannerText>
            {title && <HeaderText>{title}</HeaderText>}
            {subTitle && <SubHeaderText>{subTitle}</SubHeaderText>}
          </BannerText>
          <CardRow>
            {contentCards.map((card, i) => (
              <CardLink
                tabIndex="-1"
                key={`${card.id}_${i}`}
                image={card.image}
                title={card.title}
                cardLink={card.cardLink}
                linkText={card.linkText}
                cardPosition={i + 1}
                assemblyAnalyticsData={assemblyAnalyticsData}
              />
            ))}
          </CardRow>
        </CardBanner>
      </Container>
    </BannerBackground>
  );
};

CardLinksAssembly.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  contentCards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      image: PropTypes.object.isRequired,
      title: PropTypes.string.isRequired,
      cardLink: PropTypes.object.isRequired,
      linkText: PropTypes.string.isRequired,
    })
  ),
  removeMarginBottom: PropTypes.bool,
};

export default CardLinksAssembly;

export const ContentCardLinksAssembly = ({ contentfulData }) => (
  <CardLinksAssembly
    title={contentfulData.title}
    subTitle={contentfulData.subTitle}
    contentCards={contentfulData.contentCards}
    removeMarginBottom={contentfulData.removeMarginBottom}
  />
);

ContentCardLinksAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
